import fixtureData from '../../../../static/json/jst-erp-fixtures.json'

export const JST_TARGETS = fixtureData.targets

const productsById = fixtureData.products.reduce((result, product) => {
  result[product.id] = product
  return result
}, {})

const ordersById = fixtureData.orders.reduce((result, order) => {
  result[order.id] = order
  return result
}, {})

const orderItemsByOrderId = fixtureData.orderItems.reduce((result, item) => {
  if (!result[item.orderId]) result[item.orderId] = []
  result[item.orderId].push(item)
  return result
}, {})

const aftersaleItemsByAftersaleId = fixtureData.aftersaleItems.reduce((result, item) => {
  if (!result[item.aftersaleId]) result[item.aftersaleId] = []
  result[item.aftersaleId].push(item)
  return result
}, {})

function money(value) {
  return Number(value || 0).toLocaleString('zh-CN', { minimumFractionDigits: 2, maximumFractionDigits: 2 })
}

function compactMoney(value) {
  const amount = Number(value || 0)
  return Number.isInteger(amount) ? String(amount) : amount.toFixed(2)
}

function lineDate(value) {
  return String(value || '').replace(' ', '\n')
}

function findOrder(role) {
  return fixtureData.orders.find(order => order.role === role)
}

function getOrderProducts(orderId) {
  return (orderItemsByOrderId[orderId] || []).map(item => ({ item, product: productsById[item.productId] }))
}

export const JST_PRODUCT_LIST = fixtureData.products.map((product, index) => ({
  id: String(index + 1),
  goodsName: product.goodsName,
  goodsShortName: product.goodsShortName,
  quantity: 0,
  price: product.price,
  goodsCode: product.goodsCode,
  styleCode: product.styleCode,
  spec: product.spec
}))

const serviceOrder = findOrder('service')
export const JST_SECOND_ORDER_ROW = {
  id: 'order-1',
  orderNo: serviceOrder.internalOrderNo,
  orderTime: serviceOrder.orderTime,
  buyerNickname: serviceOrder.buyerAccount,
  receiver: serviceOrder.receiver + ' ' + serviceOrder.phone + '\n' + serviceOrder.address,
  shop: serviceOrder.store,
  status: serviceOrder.status,
  orderCode: serviceOrder.onlineOrderNo,
  payAmount: money(serviceOrder.amount),
  orderType: serviceOrder.orderType,
  expressInfo: serviceOrder.expressCompany + '\n' + serviceOrder.expressNo,
  buyerMessage: serviceOrder.buyerMessage,
  buyerRemark: serviceOrder.sellerRemark
}

export const JST_SECOND_GOODS_ROWS = getOrderProducts(serviceOrder.id).map(({ item, product }, index) => ({
  id: 'goods-' + (index + 1), image: '', goodsCode: product.goodsCode, comboGoodsCode: '', styleCode: product.styleCode,
  goodsName: product.goodsName, goodsShortName: product.goodsShortName, spec: product.spec, type: '退', orderGoodsStatus: '',
  price: compactMoney(item.unitPrice), qty: item.quantity, amount: compactMoney(item.amount), appliedReturnQty: item.appliedReturnQty,
  actualReturnQty: item.actualReturnQty, goodsAmount: compactMoney(item.amount), orderQty: item.quantity
}))

function toSecondLibraryProduct(product, index) {
  return {
    id: 'error-product-' + product.styleCode.toLowerCase() + '-' + index,
    image: '', goodsCode: product.goodsCode, comboGoodsCode: '', styleCode: product.styleCode,
    goodsName: product.goodsName, goodsShortName: product.goodsShortName, spec: product.spec, type: '退',
    orderGoodsStatus: '', price: compactMoney(product.price), qty: 1, amount: '0', appliedReturnQty: 0,
    actualReturnQty: 0, goodsAmount: '0', orderQty: 1, issueType: '错发已发'
  }
}

export const JST_ERROR_PRODUCT_LIBRARY = ['product-ksn054', 'product-ucp001', 'product-ksj0417', 'product-ksj0450']
  .map((id, index) => toSecondLibraryProduct(productsById[id], index + 1))
export const JST_ERROR_PRODUCT = { ...JST_ERROR_PRODUCT_LIBRARY[0], id: 'error-product-ksn054' }

const createOrder = findOrder('create')
export const JST_CREATE_ORDER = {
  id: 'practice-order-1', internalOrderNo: createOrder.internalOrderNo, orderDate: createOrder.orderTime,
  buyerAccount: createOrder.buyerAccount, shop: createOrder.store, status: createOrder.status, onlineOrderNo: createOrder.onlineOrderNo,
  receivableAmount: money(createOrder.amount), paidAmount: money(createOrder.amount), freight: money(createOrder.freight),
  orderType: createOrder.orderType, receiver: createOrder.receiver, buyerMessage: createOrder.buyerMessage, phone: createOrder.phone,
  address: createOrder.address, expressCompany: createOrder.expressCompany, expressNo: createOrder.expressNo, orderRemark: createOrder.sellerRemark
}

export const JST_CREATE_GOODS = getOrderProducts(createOrder.id).map(({ item, product }, index) => ({
  id: 'practice-goods-' + (index + 1), thumbnail: '', goodsCode: product.goodsCode, styleCode: product.styleCode, type: '补',
  goodsName: product.goodsName, spec: product.spec, orderGoodsStatus: '等待线上退款', goodsTag: createOrder.tags,
  unitPrice: compactMoney(item.unitPrice), goodsAmount: compactMoney(item.amount), orderQty: item.quantity, currentQty: '0',
  defectiveQty: '', currentAmount: '0', appliedReturnQty: item.appliedReturnQty, actualReturnQty: item.actualReturnQty,
  remark: '', availableStock: product.stock
}))

export const JST_PRODUCT_LIBRARY_GOODS = [
  'product-acb001',
  'product-acb002',
  'product-acb003',
  'product-acb004',
  'product-acb005',
  'product-acb006'
]
  .map(productId => productsById[productId])
  .map(product => ({
    id: 'library-' + product.styleCode.toLowerCase(), styleCode: product.styleCode, goodsCode: product.goodsCode,
    goodsName: product.goodsName, spec: product.spec, unitPrice: compactMoney(product.price), stock: product.stock
  }))

export const JST_ORDER_QUERY_ROWS = fixtureData.orders.filter(order => order.role === 'query-list').map((order, index) => ({
  id: 'order-query-' + order.internalOrderNo, seq: String(index + 1), internalOrderNo: order.internalOrderNo, tags: order.tags,
  goods: '', onlineOrderNo: order.onlineOrderNo, externalOrderNo: order.externalOrderNo, orderTime: lineDate(order.orderTime),
  paymentTime: lineDate(order.paymentTime), auditTime: lineDate(order.auditTime), buyer: '● ' + order.buyerAccount + '\n' + order.store,
  payable: compactMoney(order.amount) + '\n' + compactMoney(order.freight), profit: '', paidAmount: compactMoney(order.amount),
  additional: compactMoney(order.amount) + '\n' + compactMoney(order.amount), status: order.status,
  suggestion: order.status.indexOf('缺货') > -1 ? '1、补库存\n2、更换有库存的仓库发货\n3、更换有库存的商品发货' : '',
  selected: index === 0
}))

function aftersaleGoodsInfo(aftersale) {
  const rows = (aftersaleItemsByAftersaleId[aftersale.id] || []).map(item => {
    const product = productsById[item.productId]
    return product.goodsShortName + '　退 ×' + item.applyQty
  })
  return rows.concat('商品明细　合计：' + rows.length).join('\n')
}

function toFastAftersale(aftersale) {
  const order = ordersById[aftersale.orderId]
  const delivered = order.expressCompany ? order.expressCompany + '\n' + order.expressNo : ''
  return {
    id: aftersale.id === 'aftersale-target' ? 'aftersale-fast-target' : 'aftersale-fast-' + aftersale.aftersaleNo,
    aftersaleNo: aftersale.aftersaleNo, internalOrderNo: order.internalOrderNo, aftersaleStatus: aftersale.aftersaleStatus,
    solution: aftersale.solution, onlineStatus: aftersale.onlineStatus, onlineType: aftersale.onlineType,
    aftersaleCategory: aftersale.aftersaleCategory, goodsInfo: aftersaleGoodsInfo(aftersale), returnExpressNo: aftersale.returnExpressNo,
    returnInternationalNo: aftersale.returnInternationalNo, cargoStatus: aftersale.cargoStatus, interceptStatus: '', interceptReason: '',
    interceptTime: '', receivingWarehouse: aftersale.warehouse, warehouse: aftersale.warehouse, onlineOrderNo: order.onlineOrderNo,
    onlineAftersaleNo: aftersale.onlineAftersaleNo, issueType: aftersale.issueType, tags: aftersale.tags,
    issueRecord: aftersale.issueRecord, supplierMemo: '', supplierAftersaleStatus: aftersale.supplierRefundStatus, workOrder: '',
    buyer: '● ' + order.buyerAccount, receiver: order.receiver + ' ' + order.phone + '\n' + order.address,
    store: order.store, exceptionStatus: '', supplierRefundStatus: aftersale.supplierRefundStatus,
    applyTime: lineDate(aftersale.applyTime), confirmTime: lineDate(aftersale.confirmTime), originalOrderStatus: order.status,
    orderStatusSnapshot: order.status, deliveryExpressNo: delivered, deliveryInternationalNo: '', originalTags: order.tags,
    originalWarehouse: '淘金云仓库', originalRemark: order.sellerRemark,
    originalOfflineRemark: '', originalSalesman: '', originalPurchaseAmount: '',
    originalOrderAmount: money(order.amount) + '\n(含运费' + money(order.freight) + ')', onlineApplyAmount: money(aftersale.applyAmount),
    refundedAmount: money(aftersale.refundedAmount) + '\n查看明细', actualReceivedAmount: '0.00',
    applyReturnQty: String(aftersale.applyQty), actualReturnQty: String(aftersale.actualReturnQty), creator: '系统下载', modifier: '',
    platformDetail: '查看平台售后单详情', arbitrationStatus: '', actions: '编辑\n查看日志'
  }
}

export const JST_AFTERSALE_FAST_ROWS = fixtureData.aftersales.map(toFastAftersale)

function returnRowId(aftersale) {
  return aftersale.id === 'aftersale-target' ? 'aftersale-return-target' : 'aftersale-return-' + aftersale.aftersaleNo
}

export const JST_AFTERSALE_RETURN_ROWS = fixtureData.aftersales.map(aftersale => {
  const order = ordersById[aftersale.orderId]
  return {
    id: returnRowId(aftersale), aftersaleNo: aftersale.aftersaleNo, businessType: aftersale.businessType,
    internalOrderNo: order.internalOrderNo, applyTime: aftersale.applyTime, onlineType: aftersale.onlineType,
    aftersaleCategory: aftersale.aftersaleCategory, status: aftersale.aftersaleStatus, onlineStatus: aftersale.onlineStatus,
    cargoStatus: aftersale.cargoStatus, buyerAccount: order.buyerAccount, externalTradeNo: order.externalOrderNo,
    receivingWarehouse: aftersale.warehouse, warehouse: aftersale.warehouse, returnLogistics: aftersale.returnExpressNo,
    returnInternationalNo: aftersale.returnInternationalNo, onlineOrderNo: order.onlineOrderNo
  }
})

export const JST_AFTERSALE_RETURN_GOODS_BY_ID = fixtureData.aftersales.reduce((result, aftersale) => {
  result[returnRowId(aftersale)] = (aftersaleItemsByAftersaleId[aftersale.id] || []).map((item, index) => {
    const product = productsById[item.productId]
    return {
      id: 'aftersale-return-goods-' + aftersale.aftersaleNo + '-' + (index + 1), thumbnail: '', goodsCode: product.goodsCode,
      comboGoodsCode: '', styleCode: product.styleCode, goodsName: product.goodsName, spec: product.spec, goodsTag: aftersale.tags,
      onlineDetailAmount: compactMoney(item.amount), unitPrice: compactMoney(item.unitPrice), applyQty: item.applyQty,
      actualReturnQty: item.actualReturnQty
    }
  })
  return result
}, {})

export const JST_FIXTURE_DATA = fixtureData



// WEBPACK FOOTER //
// ./src/page/simulate/jushuitan/jstErpFixtureData.js